
import { VideoBackground } from '../components/VideoBackground'

export function HomePage() {
  return (
    <div className="video-container min-h-screen flex flex-col relative scan-lines pt-20">
      {/* Animated Video Background */}
      <VideoBackground 
        videoSrc="/media/backgrounds/space-animation.webm"
        fallbackImage="/media/backgrounds/star-wars-galaxies-sci-fi-mmo.avif"
      />
      {/* SEO Content - Hidden but accessible to search engines - 2024-12-19 */}
      <div className="sr-only">
        <h1>SWG: Origins - Star Wars Galaxies Pre-CU Server</h1>
        <h2>Join the Ultimate Star Wars Galaxies Experience</h2>
        <p>Experience the authentic Star Wars Galaxies Pre-CU era on SWG: Origins. Join thousands of players in the ultimate SWG server with custom content, active community, and endless adventures across the galaxy. Play as Jedi, Sith, bounty hunters, and more in this massive multiplayer online role-playing game.</p>
        <h3>Key Features:</h3>
        <ul>
          <li>Authentic Pre-CU Star Wars Galaxies gameplay</li>
          <li>Custom content and events</li>
          <li>Active community and guilds</li>
          <li>Space combat and ground battles</li>
          <li>Crafting and resource gathering</li>
          <li>Player vs Player combat</li>
          <li>Regular updates and new content</li>
        </ul>
      </div>
      
      {/* Holographic Particles Effect */}
      <div className="holographic-particles">
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
        <div className="holographic-particle"></div>
      </div>

      {/* Hero Section - Star Wars Crawl */}
      <section className="flex-1 relative z-10 overflow-hidden">
        <div className="star-wars-crawl">
          <div className="crawl-content">
            <div className="crawl-text">
              <h1 className="crawl-title">SWG: ORIGINS</h1>
              <p className="crawl-subtitle">Episode I</p>
              <p className="crawl-subtitle">A NEW BEGINNING</p>
              
              <div className="crawl-body">
                <p>
                  It is a time of great change in the galaxy. The Clone Wars have ended, 
                  but the Empire's grip tightens across the stars. In the shadows, 
                  brave souls seek to preserve the ways of the old Republic.
                </p>
                
                <p>
                  SWG: Origins stands as a beacon of hope, offering an authentic 
                  Star Wars Galaxies experience that captures the magic of the 
                  original Pre-CU era. Here, players forge their own destinies 
                  in a living, breathing galaxy far, far away.
                </p>
                
                <p>
                  From the bustling cities of Corellia to the dangerous wilds of 
                  Dantooine, every corner of the galaxy awaits your story. 
                  Will you become a master craftsman, a feared bounty hunter, 
                  or perhaps even a legendary Jedi?
                </p>
                
                <p>
                  The galaxy is vast, the possibilities endless. 
                  Your adventure begins now...
                </p>
              </div>
            </div>
          </div>
        </div>
        
      </section>

      {/* CTA Section - Fixed to Bottom */}
      <section className="py-3 sm:py-6 bg-slate-900/30 backdrop-blur-sm border-t border-cyan-500/20 relative z-10">
        <div className="max-w-xl mx-auto px-3 sm:px-4 text-center">
          <h2 className="text-sm sm:text-lg font-starjedi text-white mb-1 sm:mb-2 tracking-wider">
            READY TO BEGIN YOUR ADVENTURE?
          </h2>
          <p className="text-xs sm:text-sm text-gray-300">
            Forge your legend in the ultimate Star Wars Galaxies experience.
          </p>
        </div>
      </section>
    </div>
  )
}
